export { default } from './FeatureSimpleBlock'
